import React, { useEffect, useState } from 'react'
import style from './index.module.scss'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { getBreadCrumbs, flattenRoutes } from '@/utils/flatten'
import teaRoute from '@/routes/tea'
import { Link } from 'react-router-dom'

export default function index() {
	const [searchParams] = useSearchParams() //hooks只能在函数组件的顶层调用
	const location = useLocation()
	const [breadcrumbs, setBread] = useState<any[]>([])
	const navigate = useNavigate()

	const handleNavigate = (val: number) => {
		navigate(val - (breadcrumbs.length - 1))
	}

	type BreadcrumbItem = { content: string; path: string }

	useEffect(() => {
		const breadcrumbs = getBreadCrumbs({ flattenRoutes: flattenRoutes(teaRoute), location: location })
		// 修改breadcrumbs数组
		// const targetItem: BreadcrumbItem = breadcrumbs.find((i: BreadcrumbItem) => i.path.includes('/overview'))!
		// targetItem && (targetItem.content = searchParams.get('origin')!)
		setBread(breadcrumbs)
	}, [location])

	return (
		<div className={style.crumb}>
			{breadcrumbs.map((_, index) => {
				return (
					<React.Fragment key={index}>
						<span>
							<span onClick={() => handleNavigate(index)} className={style.link}>
								{_.content}
							</span>
						</span>
						{index !== breadcrumbs.length - 1 && _.content && <span>{' > '}</span>}
					</React.Fragment>
				)
			})}
		</div>
	)
}
